<template>
    <div class="map" :id="initId">
        <div class="legend-my">
            <canvas id="legend" class="legend-show" ></canvas>
            <div class="right">
                <p>{{legendObj.endValue}}</p>
                <p>{{legendObj.startValue}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import 'leaflet-draw'
import axios from '@/utils/axios.min'

import 'leaflet-velocity/dist/leaflet-velocity.css'
import 'leaflet-velocity/dist/leaflet-velocity'
import {tiledMapLayer} from '@supermap/iclient-leaflet'

import { colorpicks} from "@/utils/common"
export default {
    props:{
        initId:{
            type:String,
            default:'map'
        },
        timeRange:{
            type:Array
        },
        isplay:{
            type:Boolean
        },
        is2d:{
            type:Boolean
        },
        url: {
          type: String
        },
       collections: {
          type: Array
       },
       legendObj:{
           type:Object
       }
    },
    components:{
        // StepV
    },
    data(){
        return{
            draw:null,
            baseMap:null,
            AllCollection:[],
            timer:null,
            startTime:'',
            endTime:'',
            TimeLayerGroup:null,
            lalayerIDlist:[],
            layerIndex: 0,
            isFirst:true,
            loading:false,
            showWind:false,
            initWind:false,
            windLayerGroup:null,
            measureGroup:null
        }
    },
    watch:{
        timeRange(val){
            if(val){
                this.AllCollection = []
                this.layerIndex = 0
                this.getLIST()
            }
        },
        isplay(val){
            if(!val&&!this.is2d){
                if(this.isFirst){
                   this.getLIST()
                   this.isFirst = false
                }
                this.newTimeAnimation()
            }else{
                clearInterval(this.timer)
            }
        }
    },
    destroyed(){
        clearInterval(this.timer)
    },
    methods:{
        renderLegend(){
            let c_list = this.legendObj.principalValue.split(',')
            let a = colorpicks(c_list,100)
            var can = document.getElementById("legend");
            var cans = can.getContext('2d');
            //创建一个线性渐变对象
            var gnt1 = cans.createLinearGradient(0,160,0,0);
            a.forEach((element,index) => {
                gnt1.addColorStop(index*(1/a.length),element);
            });
            cans.fillStyle = gnt1;
            //绘制一个矩形
            cans.fillRect(0,0,240,160);
        },
        changeTime(time){
          let now = new Date(time),
              Y = now.getFullYear(),
              M = now.getMonth()+1,
              D= now.getDate()
            M = M<10?'0'+M:M;
            D = D<10?'0'+D:D;
            return Y+'-'+M+'-'+D;
        },
        newTimeAnimation(){
            let that = this
            this.timer = setInterval(() =>{
                if(that.loading){
                    return
                }
                const rootUrl = this.iserverLayerHeader + that.url
                let b = L.supermap.imageTileLayer(rootUrl, {
                    noWrap:true,
                    subdomains:["8091"],
                    collectionId: that.AllCollection[that.layerIndex].collection,
                    names: [that.AllCollection[that.layerIndex].name]
                })
                b.addTo(that.TimeLayerGroup)
                that.lalayerIDlist.push(b._leaflet_id)
                if(that.lalayerIDlist.length>2){
                    that.TimeLayerGroup.removeLayer(that.lalayerIDlist.shift())
                }
                if (that.layerIndex === that.AllCollection.length - 1) {
                    that.layerIndex = 0
                    return
                }
                that.layerIndex++
            },400)
        },
        initMap(){
            // let that = this
            let crs  = L.CRS['EPSG'+this.collections[0].baseUnderUrl]
            if(crs){
                this.baseMap = L.map(this.initId, {
                    center: [0,0],
                    maxZoom: 18,
                    crs:crs,
                    zoomControl:false,
                    attributionControl:false,
                    zoom: 1,
                });
            }else{
                this.baseMap = L.map(this.initId, {
                    center: [0,0],
                    maxZoom: 18,
                    zoomControl:false,
                    attributionControl:false,
                    zoom: 1,
                });
            }
            var url = initmapUlr+this.collections[0].underPaintingUrl
            tiledMapLayer(url,{
                noWrap:true
            }).addTo(this.baseMap);
            this.TimeLayerGroup = L.layerGroup().addTo(this.baseMap);
            this.windLayerGroup = L.layerGroup().addTo(this.baseMap);
            this.measureGroup = L.layerGroup().addTo(this.baseMap);
            
            try {
                this.addOne()
            } catch (error) {
                console.log(error);
            }
        },
        getLIST(){
            let that = this
            this.loading = true
            const startTime = this.changeTime(this.timeRange[0]) + ' 00:00:00'
            const endTime = this.changeTime(this.timeRange[1]) + ' 23:59:59'
            const collectionNames = []
            this.collections.forEach(item => {
                collectionNames.push(item.resourceName)
            })
            const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
            axios.get(url).then(res => {
              res.data.features.forEach(feature => {
                    that.AllCollection.push({
                        collection: feature.collection,
                        name: feature.assets.data.title,
                        time:feature.properties.createtime
                    })
                })
                that.loading = false
            })
        },
        addOne(){
            let that = this
            const startTime = this.changeTime(this.timeRange[0]) + ' 00:00:00'
            const endTime = this.changeTime(this.timeRange[1]) + ' 23:59:59'
            const collectionNames = []
            this.collections.forEach(item => {
                collectionNames.push(item.resourceName)
            })
            const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
            axios.get(url).then(res => {
                res.data.features.forEach(feature => {
                    that.AllCollection.push({
                        collection: feature.collection,
                        name: feature.assets.data.title,
                        time:feature.properties.createtime
                    })
                })
                that.AllCollection.splice(1,that.AllCollection.length-1)
                const rootUrl = this.iserverLayerHeader + that.url
                let b = L.supermap.imageTileLayer(rootUrl, {
                    noWrap:true,
                    subdomains:["8091"],
                    collectionId: that.AllCollection[that.layerIndex].collection,
                    names: [that.AllCollection[that.layerIndex].name]
                })
                b.addTo(that.TimeLayerGroup)
                that.lalayerIDlist.push(b._leaflet_id)
                that.layerIndex++
            })
        },
    },

    created(){

    },
    mounted(){
        this.initMap()
        this.$nextTick(() =>{
            this.renderLegend()
        })
    }
}
</script>

<style lang="scss" scoped>
.map{
    width: 100%;
    height: 100%;
    .legend-my{
        position: absolute;
        left: 0;
        bottom: 6px;
        padding-left: 12px;
        z-index: 100000;
        .right{
            position: absolute;
            left: 36px;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 160px;
            p{
                width: 47px;
                display: inline;
            }
        }
        .legend-show{
            width: 24px;
            height: 160px;
        }
    }
    
    .time-step{
        position: absolute;
        left: 260px;
        bottom: 10px;
        z-index: 100000;
    }
}
/deep/.iclient-leaflet-logo{
    display: none;
}
</style>
